import { useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { getCenterDetail } from 'app/store/modules/encarcenter';

export default function useDetail() {
	const { centerDetail } = useSelector((state) => state.encarcenter, shallowEqual);
	const { pender } = useSelector((state) => state, shallowEqual);

	const dispatch = useDispatch();
	const getDetailData = useCallback((action) => dispatch(getCenterDetail(action)), [dispatch]);
	const isError = pender.failure['encarcenter/GET_CENTER_DETAIL'];

	return {
		isError,
		getDetailData,
		centerDetail,
	};
}
